export default __webpack_public_path__ + "static/media/TwitterWhite.3ed66287.svg";